const NS = 'DashboardUserProgressBlock';
const CLS = 'radialProgress';

export class DashboardUserProgressBlock {
	constructor(element, initValue = 0) {
		this.$element = $('#radialProgress');

		this.percentage = parseFloat(this.$element.attr('data-percentage')) || initValue;
		this.maxPercentage = 100;
		this.defaultRadius = 160;

		// Variables sourced in .scss styles
		this.plainColor = '#DCDCDC';
		this.highlightColor = '#33CC66';

		// Use the DOM element
		this.canvas = this.$element.find(`.${CLS}-canvas`)[0];

		if(this.percentage < 0 || this.percentage > this.maxPercentage) {
			this.percentage = 0;
			console.error(`${NS}::Error`, 'Please supply a valid range between 0–100');
		}

		this.drawCanvas();
	}

	drawCanvas() {
		this.canvas.width = this.canvas.getBoundingClientRect().width;
		this.canvas.height = this.canvas.width;

		this.lineWidth = 4;
		this.context = this.canvas.getContext('2d');
		this.centerX = this.canvas.width / 2;
		this.centerY = this.canvas.height / 2;
		this.radius = (this.canvas.width - this.lineWidth) / 2;

		if(this.radius < 0) {
			this.radius = 0;
		}

		this.renderArc(this.percentage);
	}

	renderArc(percentage) {
		let ctx = this.context;
		let circleStart = 1.5 * Math.PI;
		let circleEnd = circleStart + ((percentage / 100) * Math.PI * 2);

		ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

		ctx.beginPath();
		ctx.arc(this.centerX, this.centerY, this.radius, circleStart, 4 * Math.PI, false);
		ctx.lineWidth = this.lineWidth;
		ctx.strokeStyle = this.plainColor;
		ctx.stroke();

		if(percentage > 0) {
			ctx.beginPath();
			ctx.arc(this.centerX, this.centerY, this.radius, circleStart, circleEnd, false);
			ctx.lineWidth = this.lineWidth;
			ctx.lineCap = 'butt';
			ctx.strokeStyle = this.highlightColor;
			ctx.fillStyle = this.highlightColor;
			ctx.stroke();
		}
	}
}
